import {
  FETCH_ARMS,
  FETCH_ARMS_SUCCESS,
  FETCH_ARMS_FAILURE,
  FOOTER_HEIGHT,
  FETCH_AVAILABLE_SERVICES_REQUEST,
  FETCH_AVAILABLE_SERVICES_SUCCESS,
  FETCH_AVAILABLE_SERVICES_FAILURE,
  START_ESERVICE,
  SUCCESS_ESERVICE,
  FAILURE_ESERVICE,
} from '../constants';

import fetch from '../core/fetch';

export function fetchDistrictArms(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_ARMS });
    return fetch(`${process.env.API_URL}/districts/arms/${prefix}`, {
      method: 'GET',
    })
      .then(r => {
        return r.json();
      })
      .then(resp => {
        dispatch({ type: FETCH_ARMS_SUCCESS, payload: resp.arms });
        return resp.arms;
      })
      .catch(error => {
        console.error('failure', error);
        dispatch({ type: FETCH_ARMS_FAILURE });
      });
  };
}

export function fetchAvailableServices() {
  return function (dispatch) {
    dispatch({ type: FETCH_AVAILABLE_SERVICES_REQUEST });
    return fetch(`${process.env.API_URL}/available_services/1`, {
      method: 'GET',
    })
      .then(r => {
        if (r.status === 200) {
          return r.json();
        } else {
          throw r.text();
        }
      })
      .then(resp => {
        dispatch({ type: FETCH_AVAILABLE_SERVICES_SUCCESS, payload: resp.services });
        return resp.services;
      })
      .catch(() => {
        dispatch({ type: FETCH_AVAILABLE_SERVICES_FAILURE });
      });
  };
}

export function saveFooterHeight(footerHeight) {
  return function (dispatch) {
    dispatch({ type: FOOTER_HEIGHT, footerHeight });
  };
}


export function runService(type, district, data) {
  const url = `${process.env.API_URL}/eservices/${district}/service/${type}`;
  return function(dispatch) {
    dispatch({ type: START_ESERVICE });
    
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(resp => {
      if(resp.status === 200) {
          const payload = resp.json();
          dispatch({ type: SUCCESS_ESERVICE, payload: payload });
          return payload;
        } else if (resp.status === 400) {
          const payload = resp.json();
          dispatch({ type: FAILURE_ESERVICE });
          return payload;
        } else {
          throw "Błąd po stronie serwera"
        }
    })
    .catch(resp => dispatch({ type: FAILURE_ESERVICE }))
  }
}


// WEBPACK FOOTER //
// src/actions/eservices.js